export const visibilityHR = (value: number | boolean) => {
  return value ? "Public" : "Private";
};
